/**
 * Emergency Help v2's addresses (M35-T06, ADR-0064). Public at `/emergency`
 * since M36's switch-over (M36-T11, ADR-0065 decision 8). This is the one place
 * they are defined.
 */
export const EMERGENCY_HELP_PATH = '/emergency'

/** Where the flow lived while it was hidden (M35). Every address under it
 * redirects to its `/emergency` twin, so old links keep working. */
export const LEGACY_EMERGENCY_HELP_PATH = '/emergency-help'
export const hospitalsPath = `${EMERGENCY_HELP_PATH}/hospitals`
export const hospitalPath = (slug: string) =>
  `${hospitalsPath}/${encodeURIComponent(slug)}`

/** Screen 4, a request for AMTC help (M36-T08), carrying the hospital. */
export const requestPath = (slug?: string) =>
  slug
    ? `${EMERGENCY_HELP_PATH}/request?hospital=${encodeURIComponent(slug)}`
    : `${EMERGENCY_HELP_PATH}/request`

/** Four screens since M36-T08 added the request. */
export const STEP_COUNT = 4
